<template>
  <v-snackbar v-model="show" :timeout="timeout" top color="primary">
    {{ message }}
    <template v-slot:action="{ attrs }">
      <v-btn small outlined dark v-bind="attrs" @click="show = false">
        Ok
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      message: "",
      timeout: 3000,
    };
  },
  created: function() {
    this.$store.watch(
      (state) => state.snack,
      () => {
        const msg = this.$store.state.snack;
        if (msg !== "") {
          this.show = true;
          this.message = this.$store.state.snack;
          this.$store.commit("setSnack", "");
        }
      }
    );
  },
};
</script>
